import axios, { AxiosRequestConfig } from 'axios';
import { User } from "./user.service";

export const AUTHORIZATION_HEADER = "Authorization"

class BaseAxios {

    private modalError: Function;
    private user = new User()

    constructor(_modalError: Function ) {
        this.setConfigDefaults();
        this.setRequest();
        this.setResponse();

        this.modalError = _modalError;
    }

    setConfigDefaults() {
        axios.defaults.baseURL =  process.env.REACT_APP_API_URL;
        
        axios.defaults.headers = {
            'Accept': 'application/json',
            'Accept-Language': 'es',
        };

    }
    
    setRequest() {
        let that = this
        axios.interceptors.request.use((request) => {
            if(that.sendAuthorization(request))
                request.headers[AUTHORIZATION_HEADER] = `Bearer ${this.user.getToken()}`
            if(request.data)
                request.headers['Content-Type'] = 'application/json'
            return request;
        }, (error) => {
            console.error(error);
            return error;
        });
    }

    setResponse() {
        let that = this;
        axios.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            if(error.response.status === 401){
                this.user.logout();
                window.location.href = '/'
            } else if(that.isHaveExcepetions(error)){
                that.modalError(error);
            }

            return error;
        });
    }

    isHaveExcepetions(error: any){
        const excepetions = [
            'VoucherNumberFormatNotValidException',
            'VoucherNotFoundException',
        ];
        
        return !excepetions.find((e) => e === error.response.data.exception)
    }

    sendAuthorization(request: AxiosRequestConfig): boolean {
        return this.user.getToken() && request.url !== "rest/auth/token";
    }
}


export default BaseAxios;
